var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "banner-mt-link-slider",
      class: { "banner-mt-link-slider--desktop": !_vm.isMobile },
    },
    [
      _c(_setup.CoreSwiper, {
        attrs: {
          "slides-per-view": 1,
          "space-between": 16,
          "has-navigation": false,
          "has-pagination": _vm.slides.length > 1,
        },
        scopedSlots: _vm._u([
          {
            key: "slides",
            fn: function ({ slideAttrs }) {
              return _vm._l(_vm.slides, function (slide) {
                return _c(
                  "div",
                  _vm._b({ key: slide.imgSrc }, "div", slideAttrs, false),
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "banner-mt-link-slider__slide d-flex flex-column",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "banner-mt-link-slider__image-wrap" },
                          [
                            _c("img", {
                              staticClass: "banner-mt-link-slider__image",
                              attrs: {
                                src: slide.imgSrc,
                                alt: slide.titleLines.join(" "),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text-h6 text-center" },
                          _vm._l(slide.titleLines, function (line, lineIndex) {
                            return _c(
                              "span",
                              { key: `${slide.imgSrc}-${lineIndex}` },
                              [
                                lineIndex !== 0 ? _c("br") : _vm._e(),
                                _vm._v(_vm._s(line) + "\n            "),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }